import { createContext } from "react";

export const CloneBatchModalContext = createContext();
